module.exports = __webpack_public_path__ + "static/media/delete-icon.62464d0f.svg";